import { Alert, Badge, Box, CssBaseline, Toolbar, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useLiveQuery } from "dexie-react-hooks";
import Nav from "../layout/Nav";
import SideNav from "../layout/SideNav";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import useOnlineStatus from "../utils/useOnlineStatus";
import { db } from "../offline/db";
import { syncQueue } from "../offline/offlineQueue";

const ProtectedRoute = (props) => {
  const drawerWidth = 240;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [open, setOpen] = useState(!isMobile);
  const login = useSelector((state) => state.auth.loginInfo.accessToken);
  const menuArray = useSelector((state) => state.dataRed.menuArray);
  const drawerOpen = useSelector((state) => state.auth.drawerOpen);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  // const login=useSelector(state=>state.auth.loginInfo)

  const isOnline = useOnlineStatus();
  const wasOffline = useRef(false);
  const pendingCount = useLiveQuery(() => db.writeQueue.count(), [], 0);
  const [bannerDismissed, setBannerDismissed] = useState(false);
  const isDrawerOpen = drawerOpen.bol ? drawerOpen.open : open;
  const bannerLeft = !isMobile && isDrawerOpen ? drawerWidth : 0;

  useEffect(() => {
    if (!isOnline) {
      wasOffline.current = true;
      setBannerDismissed(false);
    } else if (wasOffline.current) {
      wasOffline.current = false;
      syncQueue().then((syncedCount) => {
        if (syncedCount > 0) {
          toast.success(`${syncedCount} offline change${syncedCount > 1 ? "s" : ""} synced.`);
        }
      });
    }
  }, [isOnline]);

  const handleDrawerOpen = () => {
    if (drawerOpen.bol) {
      dispatch({ type: "drawerOpen", payload: { bol: drawerOpen.bol, open: !drawerOpen.open } })
    } else {
      setOpen(!open);
    }


  };

  const handleDrawerClose = () => {
    if (drawerOpen.bol) {
      dispatch({ type: "drawerOpen", payload: { bol: drawerOpen.bol, open: false } })
    } else {
      setOpen(false);
    }
  };
  const handleauthentication = () => {
    if (props.data.module === "notauthenticate" || props.data.public) {
      return true
    } else {


      const checkmenu = menuArray.filter((fil) => fil.module === props.data.module);
      console.log(props.data, checkmenu, "testFlow")
      dispatch({ type: "actionsAllow", payload: checkmenu[0] })
      if (checkmenu.length === 0) {

        return false;
      } else {

        if (props.data.action === "view") {

          return true;
        } else if (props.data.action === "create" && checkmenu[0].create) {
          return true;
        } else {
          return false;
        }
      }
    }

  };
  return (
    <>
      {login !== undefined && login !== null && login !== "" ?
        <>
          {/* {JSON.stringify({test:handleauthentication()})} */}
          {handleauthentication() ? (
            <Box sx={{ backgroundColor: "#FAFAFA", minHeight: "100vh" }}>
              <CssBaseline />
              <Nav drawerOpen={handleDrawerOpen} />
              <SideNav open={open} onClose={handleDrawerClose} drawerWidth={drawerWidth} res={"main"} />
              {!isOnline && !bannerDismissed && (
                <Alert
                  severity="warning"
                  variant="filled"
                  onClose={() => setBannerDismissed(true)}
                  sx={{
                    position: "fixed",
                    bottom: 0,
                    left: bannerLeft,
                    width: `calc(100% - ${bannerLeft}px)`,
                    zIndex: (theme) => theme.zIndex.drawer - 1,
                    borderRadius: 0,
                    justifyContent: "center",
                  }}
                >
                  You're offline — some features may not work until your connection is restored.
                </Alert>
              )}
              {pendingCount > 0 && (
                <Box
                  sx={{
                    position: "fixed",
                    bottom: !isOnline && !bannerDismissed ? (isMobile ? 88 : 72) : 16,
                    left: bannerLeft + 16,
                    zIndex: (theme) => theme.zIndex.drawer - 1,
                    backgroundColor: "#2362B4",
                    color: "#fff",
                    borderRadius: "20px",
                    px: 2,
                    py: 0.75,
                    fontSize: "0.8rem",
                    boxShadow: 3,
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                  }}
                >
                  <Badge color="warning" badgeContent={pendingCount} sx={{ mr: "0.5rem" }} />
                  {pendingCount} change{pendingCount > 1 ? "s" : ""} waiting to sync
                </Box>
              )}
              <Box
                component="main"
                sx={{
                  flexGrow: 1,
                  // p: 2,
                  p: { xs: "1rem 0.3rem", md: "0.5rem" },
                  pb: !isOnline && !bannerDismissed ? { xs: "5.5rem", md: "4.5rem" } : undefined,
                  ml: { xs: 0, md: isDrawerOpen ? `${drawerWidth}px` : 0 },
                  transition: (theme) =>
                    theme.transitions.create("margin", {
                      easing: theme.transitions.easing.easeOut,
                      duration: theme.transitions.duration.enteringScreen,
                    }),
                }}
              >
                <Toolbar />

                {props.children}
              </Box>
            </Box>
          ) : (
            <Navigate to="/notauthenticate" replace />
          )}
        </>
        : <Navigate to="/" replace />
      }
    </>
  );
};

export default ProtectedRoute;
